import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import './design-system/tokens.css';
import './design-system/global.css';

async function enableMocking() {
  if (import.meta.env.VITE_USE_MOCKS === 'false') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass', serviceWorker: { url: '/mockServiceWorker.js' } });
}

void enableMocking();

const root = document.getElementById('root');

if (!root) throw new Error('应用根节点不存在');

// 日期/时间控件统一中文显示格式（2026/08/26），跟随输入焦点补 lang 属性
document.addEventListener(
  'focusin',
  (event) => {
    const target = event.target as HTMLElement;
    if (target.matches?.('input[type="date"],input[type="datetime-local"],input[type="time"],input[type="month"]')) {
      target.setAttribute('lang', 'zh-CN');
    }
  },
  true,
);

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
